var map = {
	"./montserrat/montserrat-bold.woff2": 80711,
	"./montserrat/montserrat-regular.woff2": 18474,
	"./openSans/opensans-bold.woff2": 65031,
	"./openSans/opensans-extrabold.woff2": 47145,
	"./openSans/opensans-italic.woff2": 41198,
	"./openSans/opensans-light.woff2": 47426,
	"./openSans/opensans-regular.woff2": 9514,
	"./openSans/opensans-semibold.woff2": 87977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55254;